import {
  getFilterableChannelPlatformEntries,
  getOrderedSocialPlatformEntries,
  channelTypes,
  channelTypesVisible,
} from '@/lib/utils/channelPlatformMeta';
import { CAMPAIGN_INFLUENCER_STATUSES } from '@/lib/constants/influencerStatuses';
import type { FilterState } from './types';

export { CAMPAIGN_INFLUENCER_STATUSES };


/* ──────────────────── 채널 플랫폼 상수 ──────────────────── */

export const VISIBLE_CHANNEL_TYPES = channelTypes.filter((t) => channelTypesVisible[t]);
export const FILTERABLE_CHANNEL_PLATFORM_ENTRIES = getFilterableChannelPlatformEntries();
export const SOCIAL_PLATFORM_ENTRIES = getOrderedSocialPlatformEntries();

/* ──────────────────── 필터 초기값 ──────────────────── */

export const INITIAL_FILTER: FilterState = {
  channelName: '', channelId: '', email: '', country: [], language: [],
  subscriberCount: '', keywords: '', tags: '', categories: '',
  inclusionComment: '', recentGame: '', recentGenre: '', offer: '',
  sortBy: '', page: 1, status: [],
  channelTypeYoutube: true, channelTypeTwitch: true, channelTypeTiktok: true, channelTypeDouyin: true,
  channelTypeFacebook: true, channelTypeInstagram: true, channelTypeTwitter: true,
  channelTypeSteamCurator: true, channelTypeDiscord: true, channelTypeTelegram: true,
  channelTypeBilibili: true, channelTypeChzzk: true, channelTypeAfreeca: true,
  isRegistered: '', hasRates: '', hasDemographic: '', hasStreams: '',
  youtubeWatchLiveStreams: '', updateTiktokSocialStats: '',
  updateTiktokChannelStats: '', updateDouyinSocialStats: '',
  updateDouyinChannelStats: '', updateFacebookChannelStats: '',
  candidateGroupName: '',
  filterByCampaignId: '',
  hasCampaignHistory: '',
};

/* ──────────────────── 후보 그룹 ──────────────────── */

export const GROUP_OTHERS = 'Others';

/* ──────────────────── 영상 미리보기 수 ──────────────────── */

export const VIDEO_PREVIEW_COUNT = 4;
